import {Base64} from 'js-base64';
import {AccessToken} from '../../model';

export class JwtHelper {
  public static decodeJwtToken(token: string): AccessToken {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('The inspected token doesn\'t appear to be a JWT.');
    }
    const decoded = Base64.decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token.');
    }
    return JSON.parse(decoded.toString());
  }

  public static isTokenExpired(token: string): boolean {
    const date = this.getTokenExpirationDate(token);
    if (date === null) {
      return false;
    }
    return !(date.valueOf() > new Date().valueOf());
  }

  private static getTokenExpirationDate(token: string): Date | null {
    let decoded;
    decoded = JwtHelper.decodeJwtToken(token);
    if (!decoded.hasOwnProperty('exp')) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

}
